angular.module("accesses")

    .controller('AccessesListCtrl', ['$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', 'uiGridConstants', '$filter', 'LoginService', '$state', function ($rootScope, $scope, Restangular, gridService, modalService, uiGridConstants, $filter, LoginService, $state) {

        $rootScope.title = $filter('translate')('accesses.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('accesses.list') }
        ];

        $scope.search = {
            ip_address: "",
            uri: "",
            date_from: null,
            date_to: null
        };
       
        $scope.gridOptionsAccesses = {
            pdfTitle: $filter('translate')('accesses.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            paginationPageSizes: [50, 100, 150],
            paginationPageSize: 50,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'created_at', displayName: $filter('translate')('access.date'), enableFiltering: true, cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'', enableHiding: false, enableColumnMenu: false },
                { name: 'ip_address', displayName: $filter('translate')('access.ip_address'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'user_agent', displayName: $filter('translate')('access.user_agent'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'uri', displayName: $filter('translate')('access.uri'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'method', displayName: $filter('translate')('access.method'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'status', displayName: $filter('translate')('access.status'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'reason', displayName: $filter('translate')('access.reason'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
            ],
            getData: function (options) {
                options.ip_address = $scope.search.ip_address;
                options.uri = $scope.search.uri;
                options.date_from = $scope.search.date_from;
                options.date_to = $scope.search.date_to;

                return Restangular.all('Accesses').getList(options);
            }
            
        };

        $scope.searchAccesses = function () {
            if (angular.isDefined($scope.gridOptionsAccesses.loadData)) {
                $scope.gridOptionsAccesses.loadData(false);
            }
        }


    }])

;